import { z } from 'zod'

import {
  StudentGroupMemberSchema,
  StudentGroupSchema,
  StudentIdSchema,
  StudentSchema,
} from '~/@entities/Student'

/***************** 출결 상태 *****************/
// 퇴실 시각이 있으면 QUIT, 없으면 ENTER 다. 서버가 퇴실 시각으로 계산해 싣는다.
export const ATTENDANCE_STATUS = ['ENTER', 'QUIT'] as const

export const AttendanceStatusSchema = z.enum(ATTENDANCE_STATUS)
export type AttendanceStatus = z.infer<typeof AttendanceStatusSchema>

// 입실 기록 한 건. 퇴실하면 같은 기록에 퇴실 시각이 채워진다.
// 입실 시각은 응답 선언이 nullable 이지만 원천(AttendanceDto.enterDatetime)이 non-null 이라 늘 실린다.
export const AttendanceSchema = z.object({
  id: z.number(),
  studentId: StudentIdSchema,
  status: AttendanceStatusSchema,
  enterDatetime: z.iso.datetime({ local: true }),
  quitDatetime: z.iso.datetime({ local: true }).nullable(),
})
export type Attendance = z.infer<typeof AttendanceSchema>

// 하루(yyyy-MM-dd) 동안의 입실 기록
export const DateAttendancesSchema = z.object({
  date: z.iso.date(),
  attendanceList: z.array(AttendanceSchema),
})
export type DateAttendances = z.infer<typeof DateAttendancesSchema>

/***************** 학교급·학년별 학생의 오늘 출결 *****************/
// /students/attendance 응답(StudentGroupResponse + StudentMemberWithAttendanceResponse).
// 오늘 출결이 없으면 attendance 가, 이메일이 없으면 email 이 null 이다.
export const StudentAttendanceGroupSchema = StudentGroupSchema.extend({
  memberList: z.array(
    StudentGroupMemberSchema.extend({
      email: StudentSchema.shape.email.nullable(),
      attendance: z
        .object({ id: AttendanceSchema.shape.id, status: AttendanceStatusSchema })
        .nullable(),
    }),
  ),
})
export type StudentAttendanceGroup = z.infer<typeof StudentAttendanceGroupSchema>
